import React from 'react';
import { Loader2, Upload } from 'lucide-react';
import { BRAND } from '../kit/tokens';

// Shared drop zone (income calculator + loan-file documents, ticket 80). The
// income defaults keep the original copy; other callers pass their own.
export function DocDropZone({
  dragging, analyzing, fileInputRef, onDrop, onDragOver, onDragLeave, analyzeDocs,
  accept = '.pdf,.png,.jpg,.jpeg,.webp',
  testId = 'income-drop-zone',
  inputTestId = 'income-file-input',
  hintTestId, // optional; the income page's DOM snapshot stays byte-identical without it
  title = 'Drag & drop income documents here',
  draggingTitle = 'Release to analyze',
  subtitle = (<><b>No need to pick a doc type</b> — Audrey auto-detects paystubs, W-2s, 1099s, tax returns (Sch C / Sch E / K-1s), VOEs, bank statements, and award letters. Drop multiple files at once.</>),
  hint = 'PDF, PNG, JPG • up to 20 MB each • PTO & Holiday pay counted as base income',
  busyTitle = 'Audrey is analyzing your documents...',
  busySubtitle = 'Classifying each file, extracting all pay types, computing qualifying income.',
  minHeight = 180,
}) {
  return (
        <div className="rounded-2xl border-2 shadow-sm overflow-hidden transition-colors" style={{ borderColor: dragging ? BRAND.accent : '#e2e8f0', background: dragging ? '#F3FAE8' : '#fff' }}>
          <div
            onDrop={onDrop}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onClick={() => fileInputRef.current?.click()}
            className="p-8 flex flex-col items-center justify-center gap-2 cursor-pointer"
            style={{ minHeight }}
            data-testid={testId}
          >
            <input ref={fileInputRef} type="file" hidden multiple accept={accept} onChange={(e) => analyzeDocs(e.target.files)} data-testid={inputTestId} />
            {analyzing ? (
              <>
                <Loader2 size={40} className="animate-spin text-brand-accent" />
                <div className="font-semibold text-brand-navy">{busyTitle}</div>
                <div className="text-xs text-slate-500">{busySubtitle}</div>
              </>
            ) : (
              <>
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: dragging ? BRAND.accent : '#F3FAE8' }}>
                  <Upload size={28} style={{ color: dragging ? 'white' : BRAND.accent }} />
                </div>
                <div className="font-serif text-lg font-semibold text-brand-navy">
                  {dragging ? draggingTitle : title}
                </div>
                <div className="text-xs text-slate-500 text-center max-w-md">{subtitle}</div>
                <div className="text-[10px] text-slate-400 mt-1" data-testid={hintTestId}>{hint}</div>
              </>
            )}
          </div>
        </div>
  );
}
